
import { Component, Vue, Prop } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
@Component
export default class InfoTitle extends Vue {
  @Prop({ default: false }) private contentTitle!: boolean;
}
